import { BlogDataService } from './../../../data/repository/blog-repository/blog-data.service';
import { ActivatedRoute } from '@angular/router';
import { TextHelper } from './../../../utils/text-helper';
import { BlockPopupComponent } from './../block-popup/block-popup.component';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { SimplePopupComponent } from './../simple-popup/simple-popup.component';
import { TabBarShared } from './../../general/shared/tab-bar-shared';
import { BlogShared } from './../../general/shared/blog-shared';
import { SnackBarService } from './../../../data/repository/utils-repository/snack-bar.service';
import { BlogService } from 'src/app/data/repository/blog-repository/blog.service';
import { BlogPostModel } from './../../../core/model/object/blog-model';
import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  HostListener,
  ViewChild,
  ElementRef,
} from '@angular/core';
import { BlogUserModel } from 'src/app/core/model/object/blog-user-model';
import { BlogUserService } from 'src/app/data/repository/blog-repository/blog-user.service';
import { LoadingShared } from '../../general/shared/loading-shared';
import { Subscription } from 'rxjs';
import { SetUsernameBottomsheetComponent } from '../set-username-bottomsheet/set-username-bottomsheet.component';

@Component({
  selector: 'app-blog-profile',
  templateUrl: './blog-profile.component.html',
  styleUrls: ['./blog-profile.component.scss'],
})
export class BlogProfileComponent implements OnInit, OnDestroy {
  @ViewChild('scrollTopProfile') private myScrollContainer: ElementRef;

  @Input() username: string;
  @Input() id: number = 10;
  user: BlogUserModel;

  myUsername: string;

  postsCount = -1;
  postsPage = 0;
  postPerPage = 5;

  followers = 0;
  followees = 0;
  relationStatusSource = '';
  relationStatusTarget = '';

  dataIsReady = false;
  isMyProfile = false;

  userPosts: BlogPostModel[] = [];

  selectedPost: BlogPostModel;
  selectedPage: number;
  detailId = 10;
  settingId = 10;
  followersFolloweesId = 10;
  showSetting = false;
  showDetail = false;
  showFollowersFollowees = false;
  showCreatePost = false;

  isBlocking = false;
  isUnfollowing = false;

  midDivScrollTop = 0;
  lastScrollTop = 0;
  midDivHeight = 0;
  postsPosition = [];
  lastPostHeight = 0;
  loadImage = [];

  subscription1: Subscription;
  subscription2: Subscription;
  subscription3: Subscription;
  subscription4: Subscription;
  subscription5: Subscription;
  subscription6: Subscription;
  subscription7: Subscription;
  subscription8: Subscription;
  subscription9: Subscription;

  constructor(
    private tabBarShared: TabBarShared,
    private blogShared: BlogShared,
    private blogUserService: BlogUserService,
    private loadingShared: LoadingShared,
    private blogService: BlogService,
    private snackBarService: SnackBarService,
    private dialog: MatDialog,
    private matBottomSheet: MatBottomSheet,
    private blogData: BlogDataService,
    private textHelper: TextHelper,
    private route: ActivatedRoute,
    private blogDataService: BlogDataService
  ) {
    this.loadingShared.showLoading();
    this.username = this.route.snapshot.paramMap.get('username');
    this.blogUserService.getBlogUser().then((res) => {
      this.myUsername = res.userName;
      if (this.username === res.userName) {
        // this.user = res;
        // if (this.user.userName !== '') {
        //   this.username = this.user.userName;
        // } else {
        //   this.username = '';
        // }
        this.isMyProfile = true;
      } else {
        this.isMyProfile = false;
      }
      this.blogService.getBlogUser(this.username).then((result) => {
        if (result.isSuccess()) {
          this.user = result.getData().GetBlogUserResponse().user;
          this.followees = result.getData().GetBlogUserResponse().followees;
          this.followers = result.getData().GetBlogUserResponse().followers;
          this.relationStatusSource = result
            .getData()
            .GetBlogUserResponse().relations['source'];
          this.relationStatusTarget = result
            .getData()
            .GetBlogUserResponse().relations['target'];
          if (
            this.user.status === 'public' ||
            this.relationStatusSource === 'accept' ||
            this.isMyProfile
          ) {
            this.blogService
              .getUserPostsList(
                this.postsPage,
                this.postPerPage,
                this.user.userName
              )
              .then((res2) => {
                if (res2.isSuccess()) {
                  // this.analyticTribuneNewPageLoaded();
                  this.userPosts = res2.getData().getBlogList().posts;
                  this.postsCount = res2.getData().getBlogList().count;
                  this.dataIsReady = true;
                  setTimeout(() => {
                    this.getPostsPosition(true);
                  }, 10);
                  setTimeout(() => {
                    this.checkPersianTexts();
                  }, 10);
                } else {
                  this.snackBarService.showSnackBar(
                    'خطا در برقراری ارتباط با سرور!'
                  );
                }
                this.loadingShared.hideLoading();
              });
          } else {
            this.dataIsReady = true;
            setTimeout(() => {
              this.checkPersianTexts();
            }, 10);
            this.loadingShared.hideLoading();
          }
        } else {
          this.loadingShared.hideLoading();
          this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
        }
      });
    });
  }

  ngOnInit() {
    this.subscription1 = this.blogShared.blogOpenDetailObs$.subscribe((res) => {
      if (res.id === this.id.toString()) {
        for (let i = 0; i < this.userPosts.length; i++) {
          if (this.userPosts[i].id === res.postId) {
            this.openDetail(i);
          }
        }
      }
    });
    this.subscription2 = this.blogShared.blogOpenDetailCommentsObs$.subscribe(
      (res) => {
        if (res.id === this.id.toString()) {
          for (let i = 0; i < this.userPosts.length; i++) {
            if (this.userPosts[i].id === res.postId) {
              this.openDetailComments(i);
            }
          }
        }
      }
    );
    this.subscription3 = this.blogShared.simplePopupActionObs$.subscribe(
      (action) => {
        if (action) {
          if (this.relationStatusSource === 'block' && this.isBlocking) {
            const dialogRef = this.dialog.open(BlockPopupComponent, {
              data: { block: false, username: this.user.userName },
              width: '90%',
              panelClass: 'custom-dialog-container',
            });
            dialogRef.afterClosed().subscribe(() => {
              setTimeout(() => {
                this.isBlocking = false;
              }, 1000);
            });
          } else if (this.isBlocking) {
            const dialogRef = this.dialog.open(BlockPopupComponent, {
              data: { block: true, username: this.user.userName },
              width: '90%',
              panelClass: 'custom-dialog-container',
            });
            dialogRef.afterClosed().subscribe(() => {
              setTimeout(() => {
                this.isBlocking = false;
              }, 1000);
            });
          } else if (this.isUnfollowing) {
            this.confirmUnFollow();
            this.isUnfollowing = false;
          }
        }
      }
    );
    this.subscription4 = this.blogShared.blockPopupActionObs$.subscribe(
      (action) => {
        if (action) {
          if (this.relationStatusSource === 'block') {
            this.unBlock(this.user);
          } else {
            this.block(this.user);
          }
          this.isBlocking = false;
        }
      }
    );
    this.subscription5 = this.blogShared.removePostObs$.subscribe((remove) => {
      if (remove && this.blogShared.selectedRemovingPostId !== '') {
        let index = -1;
        this.userPosts.forEach((post, i) => {
          if (post.id === this.blogShared.selectedRemovingPostId) {
            index = i;
          }
        });
        this.userPosts.splice(index, 1);
      }
    });
    this.subscription6 = this.blogShared.usernameChangeObs$.subscribe(
      (changed) => {
        if (changed) {
          this.myUsername = this.blogShared.newUsername;
        }
      }
    );
    this.subscription7 = this.blogShared.closeCreatePostObs$.subscribe(
      (close) => {
        if (close) {
          this.closeCreatePost();
        }
      }
    );
    this.subscription8 = this.blogShared.closeAndUpdateCreatePostObs$.subscribe(
      (close) => {
        if (close) {
          this.loadPosts();
          this.closeCreatePost();
        }
      }
    );
    this.subscription9 = this.blogShared.simplePopupShareActionObs$.subscribe(
      (action) => {
        if (action) {
          this.shareProfile();
        }
      }
    );
  }

  @HostListener('window:beforeunload')
  ngOnDestroy(): void {
    this.subscription1.unsubscribe();
    this.subscription2.unsubscribe();
    this.subscription3.unsubscribe();
    this.subscription4.unsubscribe();
    this.subscription5.unsubscribe();
    this.subscription6.unsubscribe();
    this.subscription7.unsubscribe();
    this.subscription8.unsubscribe();
    this.subscription9.unsubscribe();
  }

  scroll(scrollToTop: boolean, force: boolean) {
    this.lastScrollTop = force ? 0 : this.lastScrollTop;
    this.midDivScrollTop = scrollToTop
      ? 0
      : this.myScrollContainer.nativeElement.scrollTop;
    if (Math.floor(this.midDivScrollTop / 200) >= this.lastScrollTop) {
      this.postsPosition.forEach((postPosition, i) => {
        if (
          this.midDivHeight + this.midDivScrollTop >= postPosition + 160 &&
          !this.loadImage[i]
        ) {
          this.loadImage[i] = true;
        }
      });
      if (
        this.midDivHeight + this.midDivScrollTop >=
          this.postsPosition[this.postsPosition.length - 1] +
            this.lastPostHeight +
            160 &&
        this.postsCount > (this.postsPage + 1) * this.postPerPage
      ) {
        this.showMorePosts();
      }
      this.lastScrollTop = Math.floor(this.midDivScrollTop / 200) + 1;
      // console.log(this.loadImage)
    }
  }

  getPostsPosition(scrollToTop: boolean) {
    if (scrollToTop) {
      this.midDivScrollTop = 0;
      this.lastScrollTop = 0;
      this.midDivHeight = 0;
      this.lastPostHeight = 0;
      this.postsPosition = [];
      this.loadImage = [];
    }
    const postsPosition = document.getElementsByClassName('appPostProfile');
    for (let i = 0; i < postsPosition.length; i++) {
      const p = postsPosition[i] as HTMLElement;
      this.postsPosition[i] = p.offsetTop;
      const positionInfo = p.getBoundingClientRect();
      this.lastPostHeight = positionInfo.height;
    }
    this.midDivHeight = this.myScrollContainer.nativeElement.offsetHeight;
    // console.log('postsposition', this.postsPosition, this.lastPostHeight)
    // console.log('height', this.midDivHeight)
    this.scroll(scrollToTop, true);
  }
  goback() {
    this.blogService.goback();
  }

  loadPosts() {
    this.loadingShared.showLoading();
    this.blogService
      .getUserPostsList(this.postsPage, this.postPerPage, this.user.userName)
      .then((res2) => {
        if (res2.isSuccess()) {
          // this.analyticTribuneNewPageLoaded();
          this.userPosts = res2.getData().getBlogList().posts;
          this.postsCount = res2.getData().getBlogList().count;
          setTimeout(() => {
            this.getPostsPosition(true);
          }, 10);
          this.dataIsReady = true;
        } else {
          this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
        }
        this.loadingShared.hideLoading();
      });
  }

  showMorePosts() {
    this.loadingShared.showLoading();
    this.postsPage++;
    this.blogService
      .getUserPostsList(this.postsPage, this.postPerPage, this.user.userName)
      .then((res) => {
        if (res.isSuccess()) {
          // this.analyticTribuneNewPageLoaded();
          this.userPosts = [
            ...this.userPosts,
            ...res.getData().getBlogList().posts,
          ];
          this.postsCount = res.getData().getBlogList().count;
          setTimeout(() => {
            this.getPostsPosition(false);
          }, 10);
        } else {
          this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
        }
        this.loadingShared.hideLoading();
      });
  }

  setting() {
    this.blogData.setUser(this.user);
    this.blogService.goToUserProfileSetting(this.username);
    // this.blogShared.blogZIndex++;
    // this.settingId = this.blogShared.blogZIndex;
    // this.showSetting = true;
    // setTimeout(() => {
    //   document.getElementById('settingPage').style.zIndex = '11';
    //   document.getElementById('settingPage').style.right = '0';
    // }, 100);
  }

  async closeSetting() {
    this.blogShared.blogZIndex--;
    await this.blogUserService.getBlogUser().then((res) => {
      this.username = res.userName;
    });
    await this.blogService.getBlogUser(this.username).then((result) => {
      if (result.isSuccess()) {
        this.user = result.getData().GetBlogUserResponse().user;
      }
    });
    document.getElementById('settingPage').style.right = '100%';
    setTimeout(() => {
      this.showSetting = false;
    }, 300);
  }

  follow() {
    if (this.checkUsername()) {
      this.blogService.follow(this.user.id).then((res) => {
        if (res.isSuccess()) {
          if (this.user.status === 'private') {
            this.relationStatusSource = 'pending';
            this.blogShared.pendingSuggestedUsernames.push(this.user.userName);
          } else {
            this.followers++;
            this.relationStatusSource = 'accept';
            this.blogShared.followedSuggestedUsernames.push(this.user.userName);
          }
        }
      });
    }
  }

  unFollow() {
    this.isUnfollowing = true;
    const dialogRef = this.dialog.open(SimplePopupComponent, {
      data: { titles: ['دنبال نکردن'] },
      width: '90%',
      panelClass: 'custom-dialog-container',
    });
    dialogRef.afterClosed().subscribe(() => {
      setTimeout(() => {
        this.isUnfollowing = false;
      }, 1000);
    });
  }

  confirmUnFollow() {
    this.blogService.follow(this.user.id).then((res) => {
      if (res.isSuccess()) {
        if (
          this.user.status === 'private' &&
          this.relationStatusSource === 'pending'
        ) {
          this.blogShared.pendingSuggestedUsernames.splice(
            this.blogShared.pendingSuggestedUsernames.indexOf(
              this.user.userName
            ),
            1
          );
        } else if (
          this.user.status === 'private' &&
          this.relationStatusSource === 'accept'
        ) {
          this.postsCount = -1;
          this.userPosts = [];
          this.followers--;
        } else {
          this.blogShared.followedSuggestedUsernames.splice(
            this.blogShared.followedSuggestedUsernames.indexOf(
              this.user.userName
            ),
            1
          );
          this.followers--;
        }
        this.relationStatusSource = 'none';
      }
    });
  }

  profileMoreOptions() {
    if (this.checkUsername()) {
      this.isBlocking = true;
      if (this.relationStatusSource === 'block') {
        const dialogRef = this.dialog.open(SimplePopupComponent, {
          data: { titles: ['آنبلاک کردن', 'اشتراک گذاری'] },
          width: '90%',
          panelClass: 'custom-dialog-container',
        });
      } else {
        const dialogRef = this.dialog.open(SimplePopupComponent, {
          data: { titles: ['بلاک کردن', 'اشتراک گذاری'] },
          width: '90%',
          panelClass: 'custom-dialog-container',
        });
      }
    }
  }

  block(user: BlogUserModel) {
    this.blogService.userBlock(user.id).then((res) => {
      if (res.isSuccess()) {
        this.relationStatusSource = 'block';
      }
    });
  }

  unBlock(user: BlogUserModel) {
    this.blogService.userBlock(user.id).then((res) => {
      if (res.isSuccess()) {
        this.relationStatusSource = 'none';
      }
    });
  }

  unBlockOption() {
    this.isBlocking = true;
    const dialogRef = this.dialog.open(SimplePopupComponent, {
      data: { titles: ['آنبلاک کردن'] },
      width: '90%',
      panelClass: 'custom-dialog-container',
    });
  }

  shareProfile() {
    let newVariable: any;
    newVariable = window.navigator;
    if (newVariable && newVariable.share) {
      newVariable
        .share({
          url: 'https://bentoapp.info/profile/' + this.username,
        })
        .catch((e) => {
          this.snackBarService.showSnackBar('خطا در اشتراک گذاری');
        });
    } else {
      // this.snackBarService.showSnackBar('اشتراک گذاری در جست‌و‌جوگر شما پشتیبانی نمیشود');
      const selBox = document.createElement('textarea');
      selBox.style.position = 'fixed';
      selBox.style.left = '0';
      selBox.style.top = '0';
      selBox.style.opacity = '0';
      selBox.value = 'https://bentoapp.info/profile/' + this.username;
      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      document.execCommand('copy');
      document.body.removeChild(selBox);
      this.snackBarService.showSnackBar('لینک پروفایل کپی شد');
    }
  }

  acceptFollowing() {
    this.loadingShared.showLoading();
    this.blogService.setFollowRequest(this.user.id, 'accept').then((res) => {
      if (res.isSuccess()) {
        this.blogService.getBlogUser(this.username).then((result) => {
          if (result.isSuccess()) {
            this.followees = result.getData().GetBlogUserResponse().followees;
            this.followers = result.getData().GetBlogUserResponse().followers;
            this.relationStatusSource = result
              .getData()
              .GetBlogUserResponse().relations['source'];
            this.relationStatusTarget = result
              .getData()
              .GetBlogUserResponse().relations['target'];
          }
          this.loadingShared.hideLoading();
        });
      } else {
        this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
        this.loadingShared.hideLoading();
      }
    });
  }

  rejectFollowing() {
    this.loadingShared.showLoading();
    this.blogService.setFollowRequest(this.user.id, 'ignore').then((res) => {
      if (res.isSuccess()) {
        this.blogService.getBlogUser(this.username).then((result) => {
          if (result.isSuccess()) {
            this.followees = result.getData().GetBlogUserResponse().followees;
            this.followers = result.getData().GetBlogUserResponse().followers;
            this.relationStatusSource = result
              .getData()
              .GetBlogUserResponse().relations['source'];
            this.relationStatusTarget = result
              .getData()
              .GetBlogUserResponse().relations['target'];
          }
          this.loadingShared.hideLoading();
        });
      } else {
        this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
        this.loadingShared.hideLoading();
      }
    });
  }

  openDetail(index: number) {
    this.blogShared.blogZIndex++;
    this.detailId = this.blogShared.blogZIndex;
    this.selectedPost = this.userPosts[index];
    this.tabBarShared.hideTabBar();
    this.showDetail = true;
    setTimeout(() => {
      document.getElementById('botomsheet' + this.id).style.zIndex =
        this.blogShared.blogZIndex.toString();
      document.getElementById('botomsheet' + this.id).style.top = '0';
    }, 100);
  }

  openDetailComments(index: number) {
    this.blogShared.blogZIndex++;
    this.detailId = this.blogShared.blogZIndex;
    this.selectedPost = this.userPosts[index];
    this.tabBarShared.hideTabBar();
    this.showDetail = true;
    setTimeout(() => {
      document.getElementById('botomsheet' + this.id).style.zIndex =
        this.blogShared.blogZIndex.toString();
      document.getElementById('botomsheet' + this.id).style.top = '0';
      this.blogShared.blogScrollToComments();
    }, 100);
  }

  closeDetail() {
    this.blogShared.blogZIndex--;
    document.getElementById('botomsheet' + this.id).style.top = '100%';
    setTimeout(() => {
      if (this.blogShared.blogZIndex === 10) {
        this.tabBarShared.showTabBar();
      }
      this.showDetail = false;
    }, 300);
  }

  followersFollowees(page: number) {
    this.blogData.setUser(this.user);
    this.blogData.setPage(page);
    this.blogService.goToFollowees(this.username);
    // this.blogShared.blogZIndex++;
    // this.followersFolloweesId = this.blogShared.blogZIndex;
    // this.selectedPage = page;
    // this.showFollowersFollowees = true;
    // setTimeout(() => {
    //   document.getElementById('followersFollowees' + this.id).style.zIndex =
    //     this.blogShared.blogZIndex.toString();
    //   document.getElementById('followersFollowees' + this.id).style.right = '0';
    // }, 100);
  }

  closeFollowersFollowees() {
    this.blogShared.blogZIndex--;
    document.getElementById('followersFollowees' + this.id).style.right =
      '100%';
    this.blogService.getBlogUser(this.username).then((result) => {
      if (result.isSuccess()) {
        this.followees = result.getData().GetBlogUserResponse().followees;
        this.followers = result.getData().GetBlogUserResponse().followers;
      }
    });
    setTimeout(() => {
      this.showFollowersFollowees = false;
    }, 300);
  }

  createPost() {
    this.blogDataService.setUser(this.user);
    this.tabBarShared.hideTabBar();
    this.showCreatePost = true;
    this.blogService.goTonewPost(this.user.userName);

    // this.blogShared.blogZIndex++;
    // this.tabBarShared.hideTabBar();
    // this.showCreatePost = true;
    // setTimeout(() => {
    //   document.getElementById('createPostPage' + this.id).style.zIndex =
    //     this.blogShared.blogZIndex.toString();
    //   document.getElementById('createPostPage' + this.id).style.right = '0';
    // }, 100);
  }

  closeCreatePostButton() {
    this.blogShared.exitCreatePost();
  }

  closeCreatePost() {
    if (document.getElementById('createPostPage' + this.id)) {
      this.blogShared.blogZIndex--;
      document.getElementById('createPostPage' + this.id).style.right = '100%';
      // this._sharedService.animateDownButton();
      setTimeout(() => {
        this.showCreatePost = false;
      }, 300);
    }
  }

  checkPersianTexts() {
    if (this.user.bio && this.user.bio !== '') {
      if (this.textHelper.hasTextPersian(this.user.bio)) {
        document.getElementById('bio' + this.id).style.direction = 'rtl';
        document.getElementById('bio' + this.id).style.textAlign = 'right';
      } else {
        document.getElementById('bio' + this.id).style.direction = 'ltr';
        document.getElementById('bio' + this.id).style.textAlign = 'left';
      }
    }
    if (this.user.name && this.user.name !== '') {
      if (this.textHelper.hasTextPersian(this.user.name)) {
        document.getElementById('name' + this.id).style.textAlign = 'right';
      } else {
        document.getElementById('name' + this.id).style.textAlign = 'left';
      }
    }
  }

  checkUsername(): boolean {
    if (this.myUsername === '') {
      this.matBottomSheet.open(SetUsernameBottomsheetComponent, {
        panelClass: 'custom-bottomsheet-container',
      });
      return false;
    }
    return true;
  }
}
